// Entry point for carousel bundle
// This file imports all necessary styles and scripts for the carousel widget

// Import Swiper CSS - will be bundled into carousel.bundle.css
import 'swiper/swiper-bundle.css';

// Import styles - Vite will automatically extract this into carousel.bundle.css
import '../Styles/carousel.asset.scss';
import '../Styles/loading-spinner.scss';

// Import JavaScript functionality (which includes Swiper JS import)
import './reviewCarousel.swiper.js';

// Import cleanup functionality for multi-review carousel
import { initializeCleanup } from './reviewCarousel.cleanup';

// Export cleanup function to window for use in Razor views
window.RMAWidgetCleanup = {
    initializeCleanup
};
